import { Col, Divider, Row, Space, Spin, Tabs, Timeline } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { TabsProps } from 'antd/lib';
import { MainLayout } from 'components';
import Button from 'components/Button';
import DropdownComponent from 'components/DropdownComponent';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { useMutation, useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import formatDateWithTime from 'utils/formatDateWithTime';
import { useUser } from 'contexts/User';
import PopupReasonRefuse from 'components/PopupReasonRefuse';
import { openNotificationWithIcon } from 'utils/notification';
import ApprovalApi from 'apis/ApprovalApi';
import Product from 'components/Modules/Category/Product';
import { IProduct } from 'interface/product.interface';
import { STATUS } from 'constants/reponseStatus';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import handleError401 from 'utils/handleError401';
import Info from 'components/Modules/Category/Info';
import moment from 'moment';

export default function ApproveCategoryDetail() {
  const param = useParams<any>();
  const history = useHistory();
  const queryParam = useQueryParam();
  const { user } = useUser();

  const [categoryInfo, setCategoryInfo] = useState<any>();
  const [createBy, setCreateBy] = useState<any>();

  const [appovalDetail, setAppovalDetail] = useState<any>();
  const [modalRejectOpen, setModalRejectOpen] = useState<boolean>(false);
  const [reasonRefuse, setReasonRefuse] = useState<string>();
  const [products, setProducts] = useState<IProduct[]>([]);
  const [total, setProductTotal] = useState<number>(0);
  const [loadingAllProduct, setLoadingAllProduct] = useState<boolean>(false);
  const [dataLog, setDataLog] = useState<any[]>([]);
  const [colorText, setColorText] = useState<any>();

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const { isLoading: getDetailLoading } = useQuery('getAppovalDetail', () =>
    PortfolioApi.getDetail(param?.id)
      .then((res: any) => {
        setCategoryInfo(res.data);
        setCreateBy(res.data?.user_created);
      })
      .catch((err: any) => {
        console.log(err);
      })
  );

  const { mutate: getAppovalDetail } = useMutation(
    'getAppovalDetail',
    () => PortfolioApi.getApprovalDetail(categoryInfo?.pof_code),
    {
      onSuccess: (response: any) => {
        setAppovalDetail(response?.data);
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const { mutate: listLogApprove } = useMutation(['getlogApprove'], () => {
    return PortfolioApi.getlogApprove(param?.id)
      .then((res) => {
        setDataLog(res?.data);
        setColorText(
          res?.data[0].status == 0
            ? 'text-primary-50'
            : res?.data[0].status == 1
            ? 'text-primary-50'
            : res?.data[0].status == 2
            ? 'text-primary-50'
            : 'text-red-500'
        );
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    (request: any) => PortfolioApi.getProducts(request.pof_code, params),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setProducts(response.data);
          setProductTotal(response.total);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const handleReloadProducts = () => {
    getProducts(categoryInfo);
  };

  useMemo(() => {
    getProducts(categoryInfo);
  }, [page, page_size]);

  const handleUpdateProducts = () => {
    setLoadingAllProduct(true);
    PortfolioApi.getProducts(categoryInfo?.pof_code || '', {
      page: 1,
      page_size: total,
    })
      .then((response) => {
        setLoadingAllProduct(false);
        history.push('/product-update', {
          selectedProducts: response.data,
        });
      })
      .catch((error) => {
        setLoadingAllProduct(false);
        openNotificationWithIcon('error', 'Tải sản phẩm thất bại');
      });
  };
  const ApproveOrDenyFunction = (
    status: string,
    description: string,
    POFcode: string
  ) => {
    ApprovalApi.approveOrDeny({ status, description }, POFcode)
      .then((res: any) => {
        switch (status) {
          case '1':
            if (res?.status === 'failure') {
              openNotificationWithIcon(
                'error',
                'Phê duyệt thất bại',
                res?.message
              );
            } else {
              openNotificationWithIcon('success', 'Phê duyệt thành công');
            }
            break;
          case '2':
            if (res?.status === 'failure') {
              openNotificationWithIcon(
                'error',
                'Từ chối phê duyệt thất bại',
                res?.message
              );
            } else {
              openNotificationWithIcon(
                'success',
                'Từ chối phê duyệt thành công'
              );
            }
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  if (reasonRefuse != undefined || reasonRefuse != null) {
    ApproveOrDenyFunction('2', reasonRefuse, categoryInfo?.pof_code);
  }

  const IsUerIsApprover = () => {
    const checkStage1 = (
      (
        (appovalDetail?.stage_1_PhatHanhDanhMuc || []).map((items: any) => {
          return (items?.list_user || []).filter(
            (item: any) => item?.email === user?.email
          );
        }) || []
      ).filter((items: any) => {
        return items?.length > 0;
      }) || []
    ).length;

    const checkStage2 = (
      (
        (appovalDetail?.stage_2_ChiNhanhDKMau || []).map((items: any) => {
          return (items?.list_user || []).filter(
            (item: any) => item?.email === user?.email
          );
        }) || []
      ).filter((items: any) => {
        return items?.length > 0;
      }) || []
    ).length;

    const checkStage3 = (
      (
        (appovalDetail?.stage_3_DKGioHang_ChiNhanh || []).map((items: any) => {
          return (items?.list_user || []).filter(
            (item: any) => item?.email === user?.email
          );
        }) || []
      ).filter((items: any) => {
        return items?.length > 0;
      }) || []
    ).length;

    const checkStage4 = (
      (
        (appovalDetail?.stage_4_DKGioHang_HoiSo || []).map((items: any) => {
          return (items?.list_user || []).filter(
            (item: any) => item?.email === user?.email
          );
        }) || []
      ).filter((items: any) => {
        return items?.length > 0;
      }) || []
    ).length;

    if (checkStage1 > 0) {
      return true;
    } else {
      if (checkStage2 > 0) {
        return true;
      } else {
        if (checkStage3 > 0) {
          return true;
        } else {
          if (checkStage4 > 0) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  };

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    setTitle(`${categoryInfo?.pof_code} - ${categoryInfo?.pof_name}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/approve-category-list">Phê duyệt</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            {' '}
            <a href="/approve-category-list">Danh mục</a>
          </p>
        ),
      },
      {
        title: <a href="/approve-category-list">{categoryInfo?.pof_name}</a>,
      },
    ]);
    getAppovalDetail();
    if (categoryInfo) {
      getProducts(categoryInfo);
    }
  }, [categoryInfo, createBy]);

  useEffect(() => {
    listLogApprove();
  }, [param]);

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Thông tin`,
      children: <Info portfolio={categoryInfo} />,
    },
    // {
    //   key: '1',
    //   label: `Thông tin`,
    //   children: (
    //     <InfoTab
    //       categoryInfo={categoryInfo}
    //       userCreated={createBy}
    //       approveInfo={appovalDetail}
    //     />
    //   ),
    // },
    {
      key: '2',
      label: `Sản phẩm`,
      children: (
        <Product
          pof_code={categoryInfo?.pof_code || ''}
          pof_type_code={categoryInfo?.pof_type_code || ''}
          products={products}
          total={total}
          isLoading={isProductLoading}
          onReloadProducts={handleReloadProducts}
          onUpdateProducts={handleUpdateProducts}
        />
      ),
    },
    // {
    //   key: '3',
    //   label: `Tài liệu đính kèm`,
    // },
  ];

  const listHistoryApprove = dataLog.map((item, index) => {
    return {
      children: (
        <Space className="w-full" key={index} direction="vertical">
          <Row className="flex justify-between">
            <Col>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</Col>
            <Col className={` ${colorText}`}>
              {' '}
              {item.status == 0
                ? 'Chờ phê duyệt'
                : item.status == 1
                ? 'Đã duyệt'
                : item.status == 2
                ? 'Từ chối'
                : 'Chưa tạo'}
            </Col>
          </Row>

          <p className="mt-2">
            {item.user_created.fullName + '  |  ' + item.user_created.jobTitle}
          </p>

          <Col span={24} className="text-red-500">
            {item.note}
          </Col>
        </Space>
      ),
    };
  });

  const RenderBtn = () => {
    if ((appovalDetail?.stage_1_PhatHanhDanhMuc || [])[0]?.status * 1 !== 0) {
      return (
        <>
          <Col>
            <Button disabled customClass="opacity-50 bg-green-500">
              Duyệt
            </Button>
          </Col>
          <Col>
            <Button disabled customClass="opacity-50 bg-red-500">
              Từ chối
            </Button>
          </Col>
        </>
      );
    } else {
      if (IsUerIsApprover() === false) {
        return (
          <>
            <Col>
              <Button disabled customClass="opacity-50 bg-green-500">
                Duyệt
              </Button>
            </Col>
            <Col>
              <Button disabled customClass="opacity-50 bg-red-500">
                Từ chối
              </Button>
            </Col>
          </>
        );
      } else {
        return (
          <>
            <Col>
              <Button
                onClick={() => {
                  ApproveOrDenyFunction('1', '', categoryInfo?.pof_code);
                }}
                customClass=" bg-green-500"
              >
                Duyệt
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => {
                  ApproveOrDenyFunction('2', '', categoryInfo?.pof_code);
                }}
                customClass="bg-red-500"
              >
                Từ chối
              </Button>
            </Col>
          </>
        );
      }
    }
  };

  const convertTypeName = (type_name: string) => {
    switch (type_name) {
      case 'suggest':
        return 'Khuyến nghị';
      case 'other':
        return 'Ngoài danh mục';
      case 'trial':
        return 'Hàng mới';
      default:
        return '-';
    }
  };

  const convertStatus = (status: number) => {
    switch (status) {
      case 0:
        return 'Chờ duyệt';
      case 1:
        return 'Đã phê duyệt';
      case 2:
        return 'Từ chối';
      case null:
        return 'Không xác định';
    }
  };

  return (
    <MainLayout>
      <Row
        gutter={[8, 0]}
        justify={'end'}
        style={{ marginBottom: '10px', paddingTop: '10px' }}
      >
        {RenderBtn()}
      </Row>

      <PopupReasonRefuse
        setReasonRefuse={setReasonRefuse}
        modalRejectOpen={modalRejectOpen}
        setModalRejectOpen={setModalRejectOpen}
      />

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={17}>
          <Spin spinning={getDetailLoading}>
            {' '}
            <Content>
              <Tabs
                defaultActiveKey="1"
                items={items}
                tabBarExtraContent={
                  <span
                    className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
                    style={{ color: '#4da6ff' }}
                  >
                    {convertStatus(
                      (appovalDetail?.stage_1_PhatHanhDanhMuc || [])[0]
                        ?.status * 1
                    )}
                  </span>
                }
              />
            </Content>
          </Spin>
        </Col>
        <Col span={7}>
          <Space direction="vertical" className="w-full">
            <DropdownComponent title="Thông tin đăng ký">
              <p>
                {createBy?.fullName} | {createBy?.jobTitle}
              </p>
              <DropdownComponent title="Xem chi tiết">
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Mã danh mục
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>{categoryInfo?.pof_code}</strong>
                  </Col>
                </Row>
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Loại danh mục
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>
                      {convertTypeName(categoryInfo?.pof_type_code)}
                    </strong>
                  </Col>
                </Row>
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Ngày tạo
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>
                      {formatDateWithTime(categoryInfo?.created_at)}
                    </strong>
                  </Col>
                </Row>
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Ngày đóng sổ
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>
                      {formatDateWithTime(categoryInfo?.end_date)}
                    </strong>
                  </Col>
                </Row>
                <Divider />
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Công ty
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>{createBy?.organization}</strong>
                  </Col>
                </Row>{' '}
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Phòng ban
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>{createBy?.departmentName}</strong>
                  </Col>
                </Row>{' '}
                <Row justify={'space-between'}>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    Email
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <strong>{createBy?.email}</strong>
                  </Col>
                </Row>
              </DropdownComponent>
            </DropdownComponent>

            <DropdownComponent title="Lịch sử phê duyệt">
              <Timeline items={listHistoryApprove} />
            </DropdownComponent>
          </Space>
        </Col>
      </Row>
    </MainLayout>
  );
}
